import { GridColDef } from "@mui/x-data-grid";
import { BaseDataGrid, CollapsedCard, formatDate } from "@synota-io/synota-shared-ui";
import {
  IContractBlock,
  IDashboardContractDetails,
} from "../../../../api/hooks/useContractDetails";
import { TableSummaryToolbar } from "../../../../shared/datagrid/TableSummaryToolbar";

const columns: GridColDef<IContractBlock>[] = [
  {
    field: "id",
    headerName: "ID",
    width: 80,
  },
  {
    field: "name",
    headerName: "Name",
    flex: 1,
  },
  {
    field: "block_type",
    headerName: "Block Type",
    flex: 1,
  },
  {
    field: "block_type_description",
    headerName: "Description",
    flex: 1,
  },
  {
    field: "start_date",
    valueFormatter: (v) => formatDate(v),
    headerName: "Start Date",
    type: "date",
    flex: 1,
  },
  {
    field: "end_date",
    valueFormatter: (v) => formatDate(v),
    headerName: "End Date",
    type: "date",
    flex: 1,
  },
  {
    field: "size",
    headerName: "Size",
    type: "number",
    flex: 1,
  },
  {
    field: "price",
    headerName: "Price",
    type: "number",
    flex: 1,
  },
];

export const ContractBlocksTable = ({
  contract,
  isLoading,
}: {
  contract: IDashboardContractDetails;
  isLoading: boolean;
}) => {
  return (
    <CollapsedCard title="Blocks">
      <BaseDataGrid
        density="compact"
        slots={{
          toolbar: TableSummaryToolbar,
          footer: () => null,
        }}
        loading={isLoading}
        rows={contract.blocks || []}
        columns={columns}
        autosizeOnMount={false}
        pageSizeOptions={[5]}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
      />
    </CollapsedCard>
  );
};
